// extracted by mini-css-extract-plugin
export default {"form":"_2Atvk9wmxBMRKsFRnsKYwQ","form--changed":"Xh8yp9NIWLhDUZcHBOps2","form--loading":"_2810eCPNPucwfTG1H0Z68u","spinner":"_1a41WTIATZsuP403fwY2yN"};